export class UnidadesMedidasModel {
  id_unidade: number;
  nome: string;
  sigla: string;
}



// WEBPACK FOOTER //
// ./src/app/unidades-medidas/unidades-medidas.model.ts